<script>
  import Spinner from "../ihm/ToolsSpinner.svelte";
  import CardProgressFlat from "../ihm/CardProgressFlat.svelte";
  import { coffreByBq } from "../../store/OpvcmStore";

  let montantVteTotal = 0;

  /**
   * Grosse bidouille pour avoir les infos, sinon renvoi Null pour le store
   * @param data
   */
  const displayInfo = (data) => {
    let result = [];
    if ($coffreByBq != undefined) {
      result = data;
      montantVteTotal = calculMtVte(result);
    }
    return result;
  };

  /**
   *
   * @param data
   */
  const calculMtVte = (data) => {
    let tot = 0;
    if ($coffreByBq != undefined) {
      $coffreByBq.forEach((element) => {
        tot += parseFloat(element.Diff);
      });
    }
    return tot;
  };

  /**
   *
   * @param montant
   */
  const calculPourcent = (montant) => {
    let mont = parseFloat(montant);
    let percent = 0;

    if (montantVteTotal != 0) {
      percent = (mont * 100) / parseFloat(montantVteTotal);
    }
    return new Intl.NumberFormat("fr-FR").format(Math.round(percent));
  };
</script>
<div class="container-fluid">
    {#await $coffreByBq}
        {Spinner}
    {:then data}
    {#each displayInfo(data) as item}
        <CardProgressFlat
        cardColor="blue"
        cardTitle={item.NOM}
        cardSubTitle="Total Vte. {new Intl.NumberFormat('fr-FR').format(
            item.Solde
        )}"
        cardFooterText="nbre : {item.nbre}"
        cardInfo=" soit : {new Intl.NumberFormat('fr-FR').format(item.Diff)}"
        cardPourcent={calculPourcent(item.Diff)}
        />
    {/each}
    {/await}
</div>
